import React, { useRef, useState, useEffect } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  TextInput,
  FlatList,
} from "react-native";
import { apiservice } from "../../service/service";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useRecoilValue } from "recoil";
import moment from "moment";
const { width, height } = Dimensions.get("window");

export default function page0({ getReport }) {
  const [state, setstate] = useState(getReport);
  const token = useRecoilValue(tokenState);

  async function submit(params) {
    await apiservice({
      path: "/admin/updatetracking",
      method: "put",
      body: {
        Address_tracking: params?.Address_tracking,
        tracking: params?.tracking,
        information: params?.information,
        id: params?.id,
      },
      token: token.accessToken,
    });
  }

  useEffect(() => {
    setstate(getReport);
  }, [getReport]);

  function getRealItem(item) {

    if (item.Type === 'COUPON_EVENT') {
      return {
        VIP_Status: item.VIP_Status,
        isBIBVIP: false
      }
    }

    const pay_status = item.pay_status
    const VIP_Status = item.packages?.premiumPrice == pay_status

    return {
      VIP_Status: VIP_Status,
      isBIBVIP: item.VIP_Status
    }
  }

  return (
    <View style={styles.back}>
      <FlatList
        data={state}
        extraData={state}
        scrollEnabled={false}
        renderItem={({ index, item }) => {
          console.log(state);
          return (
            <View>
              {index == 0 && (
                <View style={[styles.head, { height: 50 }]}>
                  <View style={[styles.viewhead, { width: width * 0.07 }]}>
                    <Text style={styles.textadd}>ลำดับ</Text>
                  </View>
                  <View style={[styles.viewhead, { width: width * 0.078 }]}>
                    <Text style={styles.textadd}>การชำระเงิน</Text>
                  </View>
                  <View style={[styles.viewhead, { width: width * 0.17 }]}>
                    <Text style={styles.textadd}>รายการ</Text>
                  </View>
                  <View style={[styles.viewhead, { width: width * 0.23 }]}>
                    <Text style={styles.textadd}>ชื่อ/สถานที่การจัดส่ง</Text>
                  </View>
                  <View style={[styles.viewhead, { width: width * 0.138 }]}>
                    <Text style={styles.textadd}>ประเภทการจ่ายเงิน</Text>
                  </View>
                  <View style={[styles.viewheadent, { width: width * 0.138 }]}>
                    <Text style={styles.textadd}>ข้อมูลที่จัดส่ง</Text>
                  </View>
                </View>
              )}
              <View
                style={[
                  styles.head,
                  { borderTopColor: "#fff" },
                  { backgroundColor: "#fff" },
                ]}
              >
                <View style={[styles.viewhead, { width: width * 0.07 }]}>
                  <Text style={styles.textadd}>{index + 1}</Text>
                </View>
                <View style={[styles.viewhead, { width: width * 0.078 }]}>
                  <Text style={styles.textadd}>{"สำเร็จ"}</Text>
                </View>
                <View style={[styles.viewhead, { width: width * 0.17 }]}>
                  <View style={styles.viewlow}>
                    <Text style={styles.textadd}>วิ่ง</Text>
                    <Text style={styles.textadd}>{item.event_name}</Text>
                  </View>
                  <View style={styles.viewlow}>
                    <Text style={styles.textadd}>ประเภท</Text>
                    <Text style={styles.textadd}>{item.packages?.title ?? '-'} {item.isPremium ? '(VIP)' : ''}</Text>
                  </View>
                  <View style={styles.viewlow}>
                    <Text style={styles.textadd}>บิ๊บ</Text>
                    <Text style={styles.textadd}>{item.bib} {item.isBIBVIP ? '(VIP)' : ''}</Text>
                  </View>
                  <View style={styles.viewlow}>
                    <Text style={styles.textadd}>สาขา</Text>
                    <Text style={styles.textadd}>{item?.tag ?? '-'}</Text>
                  </View>
                  <View style={styles.viewlowent}>
                    <Text style={styles.textadd}>อื่นๆ</Text>
                    <Text style={styles.textadd}>{item?.fullAddress?.name}</Text>
                  </View>
                </View>
                <View style={[styles.viewhead, { width: width * 0.23 }]}>
                  <Text style={styles.textadd}>
                    {item.orderid}
                    {(item?.fullAddress?.size
                      ? "ไซส์เสื้อ " + item?.fullAddress?.size + "\n"
                      : "ไม่ระบุ") +
                      (item?.fullAddress?.name
                        ? " ชื่อผู้ส่ง " + item?.fullAddress?.name + "\n"
                        : " ชื่อผู้ส่ง " + (item?.user_accounts?.name ?? item?.user_accounts?.username) + "\n") +
                      " " +
                      (item?.fullAddress?.ShippingAddress || "") +
                      " " +
                      (item?.fullAddress?.district || "") +
                      " " +
                      (item?.fullAddress?.subDistrict || "") +
                      " " +
                      (item?.fullAddress?.province || "") +
                      " " +
                      (item?.fullAddress?.postcode || "") +
                      " " +
                      (item?.fullAddress?.telnum
                        ? "\n" + item?.fullAddress?.telnum
                        : "\n" + item?.user_accounts?.tel)}
                    {"\n"}
                    {item.text7}
                    {"\n"}
                    {moment(item.createdAt)?.format('DD-MM-YYYY HH:mm:ss')}
                  </Text>
                </View>
                <View
                  style={[
                    styles.viewhead,
                    { width: width * 0.138 },
                    { justifyContent: "space-between" },
                    { paddingVertical: 20 },
                  ]}
                >
                  <TextInput
                    value={item?.information?.paymentType}
                    onChangeText={(text) => {
                      setstate((val) =>
                        val?.map((e, i) =>
                          i == index ? { ...e, information: { ...e.information, paymentType: text } } : e
                        )
                      );
                    }}
                    placeholder="กรอกประเภทการจ่ายเงิน"
                    style={styles.input}
                  />
                  <TouchableOpacity
                    onPress={() => submit(item)}
                    style={styles.touctto}
                  >
                    <Text style={[styles.textadd, { color: "#fff" }]}>
                      ยืนยัน
                    </Text>
                  </TouchableOpacity>
                </View>
                <View
                  style={[
                    styles.viewheadent,
                    { width: width * 0.138 },
                    { justifyContent: "space-between" },
                    { paddingVertical: 20 },
                  ]}
                >
                  <TextInput
                    value={item?.Address_tracking}
                    onChangeText={(text) => {
                      setstate((val) =>
                        val?.map((e, i) =>
                          i == index ? { ...e, Address_tracking: text } : e
                        )
                      );
                    }}
                    placeholder="กรอกผู้ให้บริการ"
                    style={styles.input}
                  />

                  <TextInput
                    value={item?.tracking}
                    onChangeText={(text) => {
                      setstate((val) =>
                        val?.map((e, i) =>
                          i == index ? { ...e, tracking: text } : e
                        )
                      );
                    }}
                    placeholder="ระบุตัวเลข"
                    style={styles.input}
                  />
                  <TouchableOpacity
                    onPress={() => submit(item)}
                    style={styles.touctto}
                  >
                    <Text style={[styles.textadd, { color: "#fff" }]}>
                      ยืนยัน
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          );
        }}
      />
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    width: width * 0.825,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    zIndex: -99
  },
  head: {
    width: width * 0.8224,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
    borderWidth: 0.5,
    borderColor: "#666666",
  },
  detail: {
    width: width * 0.825,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
    borderLeftWidth: 0.5,
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderColor: "#666666",
  },
  viewhead: {
    borderRightWidth: 0.5,
    borderColor: "#666666",
    justifyContent: "center",
    paddingHorizontal: 10,
  },
  viewheadent: {
    justifyContent: "center",
  },
  viewlow: {
    flexDirection: "row",
    width: width * 0.17,
    justifyContent: "space-between",
    alignSelf: "center",
    borderBottomWidth: 0.5,
    borderColor: "#666666",
    height: 50,
    paddingHorizontal: 10,
  },
  viewlowent: {
    flexDirection: "row",
    width: width * 0.17,
    justifyContent: "space-between",
    alignSelf: "center",
    height: 50,
    paddingHorizontal: 10,
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginVertical: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#172B4D",
    alignSelf: "center",
    textAlign: "center",
  },
  input: {
    width: width * 0.1,
    height: 30,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#666666",
    paddingLeft: 20,
    alignSelf: "center",
  },
  touctto: {
    width: width * 0.1,
    height: 30,
    backgroundColor: "#4B4B48",
    borderRadius: 5,
    justifyContent: "center",
    alignSelf: "center",
  },
});
